import { Link } from "@/i18n/navigation";
import { byPrefixAndName } from "@awesome.me/kit-12cf79935c/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Image from "next/image";

export default function PopularRouteImageCard({ item }) {
  return (
    <Link key={item.RedirectUrl} href={item.RedirectUrl} className="w-full">
      <div className="relative overflow-hidden rounded-lg shadow-sm">
        <Image
          src={item?.ImageUrl || ""}
          alt="cheapestflight-image"
          width={400}
          height={253}
          className="object-cover"
        />
        <div className="gradient-overlay absolute inset-0" />
        <div className="absolute bottom-6 left-6 z-10 space-y-2 text-white">
          <div className="flex flex-row flex-wrap items-center gap-[6px] text-xl/[26px] font-semibold">
            {" "}
            <span>{item.Origin}</span>
            <FontAwesomeIcon
              className="h-6 w-6"
              icon={byPrefixAndName.fak["half-right-arrow"]}
            />
            <span>{item.Destination}</span>
          </div>
          <div className="flex flex-row flex-wrap">
            <span
              className="text-base font-semibold"
              dangerouslySetInnerHTML={{ __html: item.StartingPriceText }}
            ></span>
          </div>
        </div>
      </div>
    </Link>
  );
}
